import { getScrollContainer } from '@theme/scroll-container';

/**
 * Dev-only: `shopify theme dev` re-renders a whole section on every edit to
 * a `{% stylesheet %}` block (there's no CSS-only hot reload for CSS embedded
 * in a section file, only for standalone assets/*.css), which resets scroll
 * position on every save. Remembers scroll position across reloads via
 * sessionStorage, independent of Horizon's own history.state-based restore
 * (@theme/scroll-container) which targets real navigation, not dev reloads.
 * Gated to localhost so this never runs against a real storefront.
 */
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
  const STORAGE_KEY = 'akr:devScrollTop';

  let pendingSave = false;

  function saveScrollTop() {
    pendingSave = false;
    sessionStorage.setItem(STORAGE_KEY, String(getScrollContainer().scrollTop));
  }

  function scheduleSave() {
    if (pendingSave) return;
    pendingSave = true;
    requestAnimationFrame(saveScrollTop);
  }

  window.addEventListener('scroll', scheduleSave, { passive: true, capture: true });
  window.addEventListener('pagehide', saveScrollTop);

  const saved = Number(sessionStorage.getItem(STORAGE_KEY));

  if (Number.isFinite(saved) && saved > 0) {
    const restore = () => getScrollContainer().scrollTo({ top: saved, behavior: 'instant' });
    restore();
    // Images/fonts finishing after the initial restore change page height —
    // a second pass once everything's loaded lands on the right spot.
    window.addEventListener('load', restore, { once: true });
  }
}
